export function formatAvatarInitials(...names: string[]): string {
  return names.map((name) => name[0] || '').join('');
}
